module.exports = __webpack_public_path__ + "id.48f1c225ecfa3b24f185.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/id.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/id.svg
// module chunks = styles